import React from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import apexLogo from '../assets/images/apex-logo.avif';
import instagramIcon from '../assets/images/instagram.png';
import twitterIcon from '../assets/images/twitter.png';
import linkedinIcon from '../assets/images/linkedin.png';
import youtubeIcon from '../assets/images/youtube.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { href: '/about-us', text: 'About Us' },
    { href: '/community', text: 'Join Our Community' },
    { href: '/past-events', text: 'Past Events' },
    { href: '/privacy-policy', text: 'Privacy Policy' }
  ];

  const socialLinks = [
    {
      href: 'https://www.instagram.com/apexcxos/',
      icon: instagramIcon,
      alt: 'Instagram',
      title: 'Instagram'
    },
    {
      href: 'https://x.com/ApexCXOs',
      icon: twitterIcon,
      alt: 'Twitter',
      title: 'Twitter'
    },
    {
      href: 'https://www.linkedin.com/company/apexcxos/',
      icon: linkedinIcon,
      alt: 'LinkedIn',
      title: 'LinkedIn'
    },
    {
      href: 'https://www.youtube.com/@apexcxos',
      icon: youtubeIcon,
      alt: 'YouTube',
      title: 'YouTube'
    }
  ];

  const contactInfo = [
    { href: 'tel:+971 58 552-1801', text: '+971 58 552-1801' },
    { href: 'tel:+91 94081-07366', text: '+91 94081-07366' },
    { href: 'mailto:contact@apexcxos.com', text: 'contact@apexcxos.com' }
  ];

  return (
    <footer className="footer-section pb-4 pt-4">
      <Container>
        <Row>
          {/* Left Column - Logo and Description */}
          <Col lg={4} className='p-0 text-center text-lg-start mb-4 mb-lg-0'>
            <a className="footer-brand d-lg-flex d-block align-items-center" href="/">
              <img
                src={apexLogo}
                className="footer-apex-logo"
                alt="logo"
              />
            </a>
            <div className="pt-3">
              <p className="footer-text">
                ApexCXOs is a global leadership forum uniting CISOs, CIOs, CTOs, and CDOs to drive
                change, create impact, and lead in technology.
              </p>
            </div>
            <div className="footer-social d-flex gap-3 pt-0 pb-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.title}
                >
                  <img
                    src={social.icon}
                    alt={social.alt}
                    className="social-icon"
                  />
                </a>
              ))}
            </div>
          </Col>
          {/* <Row> */}
            {/* Middle Column - Quick Links */}
            <Col lg={3} className="offset-lg-1 col-sm-6 col-lg-3">
              <h4 className="py-3">Quick Links</h4>
              <nav className="footer-links d-flex flex-column pe-3">
                {footerLinks.map((link, index) => (
                  <a
                    key={index}
                    className="pb-2"
                    href={link.href}
                  >
                    {link.text}
                  </a>
                ))}
              </nav>
            </Col>

            {/* Right Column - Contact Information */}
            <Col lg={3} className="offset-lg-1 col-sm-6 col-lg-3">
              <div className="footer-content gap-4">
                <h4 className="py-3">Get in Touch</h4>
                <nav className="footer-links d-flex flex-column pe-3">
                  {contactInfo.map((contact, index) => (
                    <a
                      key={index}
                      className="pb-2"
                      href={contact.href}
                    >
                      {contact.text}
                    </a>
                  ))}
                </nav>
              </div>
            </Col>
          {/* </Row> */}
        </Row>
      </Container>

      {/* Footer Bottom */}
      <div className="footer-bottom pt-2 mt-3">
        <Container>
          <Row className="align-items-center text-center text-lg-start">

            {/* Copyright */}
            <Col lg={6} className="footer-copy">
              <p className="mb-0">
                Copyright © {currentYear} ApexCXOs, All rights reserved.
              </p>
            </Col>

            {/* Powered By */}
            <Col lg={6} className="footer-powered text-lg-end">
              <p className="mb-0">
                Powered By :{' '}
                <a
                  href="https://www.barodaweb.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-powered-link"
                >
                  Barodaweb | The E-Catalogue Designer
                </a>
              </p>
            </Col>

          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
